/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import * as DraftJS from "draft-js";
import { Descendant } from "slate";

import { draftBlocksToSlateChildren } from "src/components/ViennaEditor/lib/helpers";

/**
 * Originally, these were string extensions, but this led to a lot of confusing runtime errors.
 */
export class StringUtils {
  public static isURL(string: string): boolean {
    try {
      new URL(string);
      return true;
    } catch {
      return false;
    }
  }

  public static removeWhitespace(string: string): string {
    return string.replace(/\s/g, "");
  }

  public static removeAllParamsFromURLString(string: string): string {
    return string.split("?")[0];
  }

  public static convertToSlateContent(string: string): Descendant[] {
    // ready for something hilariously awful...
    const draftJSBlocks = DraftJS.convertToRaw(DraftJS.ContentState.createFromText(string)).blocks;
    return draftBlocksToSlateChildren(draftJSBlocks);
    // ... I literally don't see another way in the docs...
  }

  public static parseToken(token: string): Record<string, any> {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        Buffer.from(base64, "base64")
          .toString()
          .split("")
          .map((c) => {
            return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    } catch (err) {
      return {};
    }
  }
}
